import { gql } from '@apollo/client';
export const APPROVAL_DEADLINE_FIELDS = gql `
  fragment ApprovalDeadlineFields on ApprovalDeadline {
    minInterval {
      days
      backward
    }
    minIntervalBasedOn
    maxInterval {
      days
      backward
    }
    maxIntervalBasedOn
    reminderDays
  }
`;
export const APPROVAL_POLICY_CONFIG_FIELDS = gql `
  ${APPROVAL_DEADLINE_FIELDS}
  fragment ApprovalPolicyConfigFields on ApprovalPolicyConfig {
    enableDeadline
    deadline {
      ...ApprovalDeadlineFields
    }
    enableWorkflow
    workflowId
    enableDocumentDeadline
    enableCourseDropoff
    documentDeadline {
      ...ApprovalDeadlineFields
    }
    optionalDocument
  }
`;
const PROGRAM_FIELDS_FOR_POLICY = gql `
  fragment ProgramFieldsForPolicy on BenefitProgram {
    id
    fieldOfStudyId
    schoolId
    programLevelId
  }
`;
export const MY_BENEFITS = gql `
  ${PROGRAM_FIELDS_FOR_POLICY}
  ${APPROVAL_POLICY_CONFIG_FIELDS}
  query MY_BENEFITS($spec: BenefitSpec!) {
    myBenefits(spec: $spec) {
      programs {
        program {
          ...ProgramFieldsForPolicy
        }
        programLevels
        singleExpenseDate {
          label
          tooltip
          description
        }
      }
      fundings {
        program {
          ...ProgramFieldsForPolicy
        }
        cap
        requested
        spent
        remaining
        currency
        periodStart
        periodEnd
        lifetimeCap
        lifetimeRemaining
        ruleId
        isUnlimited
      }
      eligibilities {
        program {
          ...ProgramFieldsForPolicy
        }
        isEligible
        enableEligibilityLock
        enablePreimbursement
      }
      approvalChains {
        program {
          ...ProgramFieldsForPolicy
        }
        programApproval {
          ...ApprovalPolicyConfigFields
        }
        paymentRequestApproval {
          ...ApprovalPolicyConfigFields
        }
        preimbursementApproval {
          ...ApprovalPolicyConfigFields
        }
      }
      schools {
        program {
          ...ProgramFieldsForPolicy
        }

        schoolOption
        countries
        accreditations
        schools
        enforceFieldsOfStudy
        otherSchool
        otherFieldOfStudy
        pickList {
          label
          tooltip
          enabled
        }
        requireProgramName
      }
      expenses {
        program {
          ...ProgramFieldsForPolicy
        }
        allowCourses
        allowBooks
        allowMaterials
        allowFees
        allowFeeTypes
        allowScholarships
        feeTypes
      }
      academics {
        program {
          ...ProgramFieldsForPolicy
        }
        minGradeReq
        minCgpaReq
        gradePayouts
        policyType
        maxCgpa
        graceCredits
        preimbursementPayoutPct
        preimbursementPayoutLimit
      }
      budgets {
        program {
          ...ProgramFieldsForPolicy
        }
        budgetLimit
        budgetYears {
          year
          amount
          segments
        }
        approvalMode
        switchCriteria {
          type
          value
        }
        workflowId
        stopRequestsOnLimit
      }
    }
  }
`;
export const GET_CURRENT_USER_ENTITY_POLICIES = gql `
  query GET_CURRENT_USER_ENTITY_POLICIES($ruleTypes: [String!]!) {
    getCurrentUserEntityPolicies(ruleTypes: $ruleTypes)
  }
`;
export const IS_ELIGIBLE = gql `
  query IS_ELIGIBLE {
    isEligible
  }
`;
export const FUNDING_SUMMARY = gql `
  query FUNDING_SUMMARY {
    fundingSummary {
      currency
      periodStart
      periodEnd
      currentYearCap
      currentYearCapOriginal
      currentYearSpent
      currentYearRemaining
      isCapReduced
      hasLifetimeCap
      lifetimeCap
      lifetimeSpent
      lifetimeRemaining
      hasMultipleFundingPolicies
      isUnlimited
    }
  }
`;
export const FUNDING_OVERVIEW = gql `
  query FUNDING_OVERVIEW($period: FundingPeriod!) {
    fundingOverview(period: $period) {
      fundingSummary {
        currency
        periodStart
        periodEnd
        currentYearCap
        currentYearCapOriginal
        currentYearSpent
        currentYearRemaining
        isCapReduced
        hasLifetimeCap
        lifetimeCap
        lifetimeSpent
        lifetimeRemaining
        hasMultipleFundingPolicies
        isUnlimited
      }
      ruleGroups {
        ruleId
        currency
        cap
        lifetimeCap
        programs {
          id
          programName
          programLevelName
          fieldOfStudyName
          otherFieldOfStudy
        }
        items {
          id
          amountRequested
          createdAt
          programId
          programName
        }
        totalRequested
        limitForPeriod
        remainingForPeriod
        isUnlimited
      }
      ruleTotals {
        totalSpentAndRequested
        totalLeft
        totalLimit
      }
      hasZeroFundingActivity
    }
  }
`;
export const BUDGET_DETAILS = gql `
  query BudgetDetails($spec: BudgetSpec!) {
    budgetDetails(spec: $spec) {
      amountRequested
      amountApproved
      amountEarmarked
      budgetTotal
      budgetRemaining
      budgetYear
      budgetSegment
    }
  }
`;
